var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import memoizeOne from 'memoize-one';
import { featureFlags } from 'utils/featureFlagging/featureFlags';
/** Checks if shared workers are supported the feature flag is enabled */
export const getUseSharedWorker = memoizeOne(() => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (!('SharedWorker' in window)) {
            return false;
        }
        const { useSharedWorker } = featureFlags.get(['use-shared-worker']);
        // Default to false if feature flag isn't returned
        return useSharedWorker !== null && useSharedWorker !== void 0 ? useSharedWorker : false;
    }
    catch (error) {
        console.warn(error);
        return false;
    }
}));
